import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { courseEnrollmentsCrudConfig } from "../consts";

export const {
  fetchAllActionFactory: fetchAllCourseEnrollmentsActionFactory,
  createActionFactory: createCourseEnrollmentActionFactory,
  deleteActionFactory: deleteCourseEnrollmentActionFactory
} = makeCrudStateActionFactories(courseEnrollmentsCrudConfig);
